import { AccordionRowVariantType } from '../../../../../../components/accordionRow/types/accordionRowVariantType';
export const getRegularStyles = (FOUNDATIONS, FONT) => {
    return {
        [AccordionRowVariantType.REGULAR]: {
            rootContainer: {
                position: 'relative',
                width: '100%',
                display: 'flex',
                flex_direction: 'column',
                border_top: `${FOUNDATIONS.size_25} solid ${FOUNDATIONS.color_comp_tableslist_lineseparator_regular_border}`,
                border_bottom: `${FOUNDATIONS.size_25} solid ${FOUNDATIONS.color_comp_tableslist_lineseparator_regular_border}`,
                transition: `height ${FOUNDATIONS.duration_150} ease-out`,
            },
            headingContainer: {
                width: '100%',
            },
            headerContainer: {
                width: '100%',
                text_align: 'left',
                cursor: 'pointer',
                padding: FOUNDATIONS.spacing_250,
            },
            bodyContainer: {
                z_index: 1,
                width: '100%',
                padding_left: FOUNDATIONS.spacing_250,
                padding_right: FOUNDATIONS.spacing_250,
                padding_bottom: FOUNDATIONS.spacing_250,
            },
        },
    };
};
//# sourceMappingURL=regular.js.map